import React from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  Header,
  Icon,
} from 'semantic-ui-react';

const LeftAlignedAccordionHeaderTitle = ({ label, ...props }) => (
  <Accordion.Title
    as={Header}
    style={{ textAlign: 'left' }}
    {...props}
  >
    <Icon name="dropdown" />
    {label}
  </Accordion.Title>
);

LeftAlignedAccordionHeaderTitle.propTypes = {
  label: PropTypes.string.isRequired,
};

export default LeftAlignedAccordionHeaderTitle;



// WEBPACK FOOTER //
// ./src/components/reusable/LeftAlignedAccordionHeaderTitle.js